import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function JoinPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    address: '',
    country: '',
    occupation: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic will be handled by the form URL
    console.log('Form submitted:', formData);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">Join the PAAM Family</h1>
          <p className="text-xl max-w-4xl mx-auto">
            Become a Part of the Apostolic Mandate - Step into divine alignment, 
            apostolic training, and global fellowship in the Body of Christ
          </p>
        </div>
      </section>

      {/* Welcome Message */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Welcome to the Global Family of the Mandate</h2>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Joining the Peter Akinnubi Apostolic Mandate (PAAM) is more than signing up for a ministry—it is 
              stepping into divine alignment, apostolic training, and global fellowship in the Body of Christ. 
              We believe that every believer must be grounded, guided, and grown through the doctrine of Christ.
            </p>
          </div>
        </div>
      </section>

      {/* Step One - Training Program */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-white text-2xl font-bold">1</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">PAAM Global Mandate Training Program</h2>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto">
              Before anyone can officially join the PAAM Family, they must first complete the 
              <strong> Free 60-day intensive online course</strong> that lays the doctrinal and apostolic foundation of the Mandate.
            </p>
          </div>

          {/* Training Modules */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-[#b8144a]">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold">1</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">Interpreting the Scriptures Through Christ</h3>
                </div>
                <p className="text-gray-700 mb-2">
                  Learn how to rightly divide the Word of Truth using Christ as the lens of all Bible interpretation.
                </p>
                <span className="text-[#b8144a] font-semibold">15 days of Training</span>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-[#b8144a]">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold">2</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">The Ministry of Moses</h3>
                </div>
                <p className="text-gray-700 mb-2">
                  Explore the call, journey, and limitations of Moses as a type of Christ and apostolic foundations.
                </p>
                <span className="text-[#b8144a] font-semibold">10 days of Training</span>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-[#b8144a]">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold">3</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">From Moses to Messiah</h3>
                </div>
                <p className="text-gray-700 mb-2">
                  The heart of the mandate. Discover how Christ is the fulfillment of all things.
                </p>
                <span className="text-[#b8144a] font-semibold">10 days of Training</span>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-[#b8144a]">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold">4</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">The Apostolic Doctrine</h3>
                </div>
                <p className="text-gray-700 mb-2">
                  Unveil the doctrine of Christ as taught by the apostles and the rise of the Ecclesia.
                </p>
                <span className="text-[#b8144a] font-semibold">10 days of Training</span>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-[#b8144a]">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold">5</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">From Mandate to Movement</h3>
                </div>
                <p className="text-gray-700 mb-2">
                  Discover how the apostolic fire becomes a global engine through the Nine Mandates of PAAM.
                </p>
                <span className="text-[#b8144a] font-semibold">15 days of Training</span>
              </div>

              <div className="bg-[#b8144a] text-white p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-4">Training Features</h4>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Self-paced learning
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Interactive assignments
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Progress tracking
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line mr-2"></i>
                    Digital certification
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Registration Section - Updated */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Start Your Journey Today</h2>
            <p className="text-xl text-gray-700">
              Complete your registration through our official PAAM portal or download our mobile app to begin your 60-day Global Mandate Training Program
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-xl shadow-lg text-center">
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Register Online</h3>
              <p className="text-gray-700 mb-6">
                Access the complete PAAM Global Mandate Training Program through our secure online portal
              </p>
              <a
                href="https://portal.paamorgintl.org/start"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#b8144a] hover:bg-[#a01240] text-white px-12 py-4 rounded-full text-lg font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer inline-block"
              >
                Register at PAAM Portal
              </a>
            </div>

            <div className="border-t border-gray-300 pt-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Download Mobile App</h3>
              <p className="text-gray-700 mb-6">
                Get the PAAM mobile app for training on-the-go, progress tracking, and global fellowship
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a
                  href="https://play.google.com/store/apps/details?id=org.paamorgintl.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <i className="ri-google-play-fill text-2xl mr-3"></i>
                  <div className="text-left">
                    <div className="text-xs">Get it on</div>
                    <div className="text-lg font-semibold">Google Play</div>
                  </div>
                </a>
                
                <a
                  href="https://apps.apple.com/app/paam-global-mandate/id123456789"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <i className="ri-apple-fill text-2xl mr-3"></i>
                  <div className="text-left">
                    <div className="text-xs">Download on the</div>
                    <div className="text-lg font-semibold">App Store</div>
                  </div>
                </a>
              </div>
            </div>

            <div className="mt-8 p-6 bg-[#b8144a]/10 rounded-lg">
              <div className="flex items-center justify-center mb-3">
                <i className="ri-information-line text-[#b8144a] text-xl mr-2"></i>
                <h4 className="text-lg font-semibold text-gray-900">What You'll Get</h4>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">
                <div className="flex items-center">
                  <i className="ri-check-line text-[#b8144a] mr-2"></i>
                  <span>Personal training dashboard</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-[#b8144a] mr-2"></i>
                  <span>Progress tracking system</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-[#b8144a] mr-2"></i>
                  <span>Digital certification</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-[#b8144a] mr-2"></i>
                  <span>CFN center connection</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Step Two - CFN */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-white text-2xl font-bold">2</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Begin Your Apostolic Journey in CFN</h2>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto">
              Christ Family Network (CFN) is the official gateway fellowship platform of PAAM. 
              Every new member, after completing the 60-day mandate training, will be connected to a CFN center.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Divine Order</h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center mt-1">
                      <i className="ri-close-line text-white text-sm"></i>
                    </div>
                    <p className="text-gray-700">You cannot become a member of CFN without first completing the Mandate Training</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center mt-1">
                      <i className="ri-close-line text-white text-sm"></i>
                    </div>
                    <p className="text-gray-700">You cannot become a member of PAAM without passing through CFN</p>
                  </div>
                </div>
                <p className="text-[#b8144a] font-semibold mt-6">This is divine order. This is apostolic structure.</p>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Diverse%20group%20of%20believers%20in%20fellowship%20and%20discipleship%20training%2C%20Christ%20Family%20Network%20meeting%20with%20people%20studying%20Bibles%20together%2C%20apostolic%20teaching%20session%20with%20warm%20community%20atmosphere%2C%20global%20unity%20in%20Christ%20with%20people%20from%20different%20nations%20learning%20together&width=600&height=400&seq=cfn-journey-1&orientation=landscape"
                alt="CFN Journey"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Dashboard Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Your Personal Dashboard</h2>
            <p className="text-xl text-gray-700">Everything you need for your apostolic journey in one place</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-dashboard-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Training Progress Tracker</h4>
              <p className="text-gray-600 text-sm">Monitor your progress through all five modules</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-mail-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Daily Email Reminders</h4>
              <p className="text-gray-600 text-sm">Stay on track with automated study reminders</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-file-upload-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Assignment Uploads</h4>
              <p className="text-gray-600 text-sm">Submit and track your training assignments</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-award-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Digital Certificate</h4>
              <p className="text-gray-600 text-sm">Receive your official PAAM certification</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-id-card-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">PAAM ID Card</h4>
              <p className="text-gray-600 text-sm">Get your unique PAAM reference number</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-team-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Center Connection</h4>
              <p className="text-gray-600 text-sm">Connect with your local CFN center</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Join the Sound. Become the Mandate.</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            The nations are waiting for sons. The harvest is ready. The sound is rising. 
            Step in. Be trained. Be formed. Be sent.
          </p>
          <p className="text-2xl font-semibold mb-8">
            Welcome to Peter Akinnubi Apostolic Ministry - From Mandate to Movement
          </p>
          <button className="bg-white text-[#b8144a] px-12 py-4 rounded-full text-xl font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
            Start Your Journey Now
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
